module.exports = __webpack_public_path__ + "static/media/trial-mac-old.001508c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trial-mac-old.png
// module id = 378
// module chunks = 3